const Tag = ({ item }) => {
  console.log(item, "item");
  return item === 1 ? (
    <div className="font-text-bold center-text">No aclarado</div>
  ) : item === 2 ? (
    <div className="font-text-bold center-text">Pendiente</div>
  ) : item === 3 ? (
    <div className=" font-text-boldRed  center-text">Rechazado</div>
  ) : item === 4 || item === "Aclarado" ? (
    <div className="font-text-boldGreen  center-text">Aclarado</div>
  ) : item === 5 || item === "Incobrable" ? (
    <div className="font-text-boldBlue center-text">Incobrables</div>
  ) : item === 6 || item === "Seguimiento CxC" ? (
    <div className="font-text-boldBlue center-text">Seguimiento CxC</div>
  ) : item === 7 || item === "Cancelado" ? (
    <div className="font-text-boldBlue center-text">Cancelado</div>
  ) : (
    ""
  );
};

export default Tag;
